import { useState } from "react";
import { Users, Mountain, ListChecks, Settings, QrCode, History, ScrollText, Tag } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { hasRole } from "../../lib/roles";
import AdminUsers from "./AdminUsers";
import AdminFronts from "./AdminFronts";
import AdminQuestions from "./AdminQuestions";
import AdminSettings from "./AdminSettings";
import AdminQRCodes from "./AdminQRCodes";
import AdminStatusHistory from "./AdminStatusHistory";
import AdminAuditLog from "./AdminAuditLog";
import AdminRoles from "./AdminRoles";

const TABS = [
  { key: "users", label: "Utilisateurs", icon: Users, roles: ["ADMINISTRATEUR"] },
  { key: "roles", label: "Rôles", icon: Tag, roles: ["ADMINISTRATEUR"] },
  { key: "questions", label: "Questions", icon: ListChecks, roles: ["RESPONSABLE", "ADMINISTRATEUR"] },
  { key: "fronts", label: "Fronts", icon: Mountain, roles: ["ADMINISTRATEUR"] },
  { key: "settings", label: "Paramètres", icon: Settings, roles: ["RESPONSABLE", "ADMINISTRATEUR"] },
  { key: "qrcodes", label: "QR Codes", icon: QrCode, roles: ["RESPONSABLE", "ADMINISTRATEUR"] },
  { key: "history", label: "Historique des statuts", icon: History, roles: ["RESPONSABLE", "ADMINISTRATEUR"] },
  { key: "journal", label: "Journal d'audit", icon: ScrollText, roles: ["RESPONSABLE", "ADMINISTRATEUR"] },
];

export default function AdminLayout() {
  const { user } = useAuth();
  const visibleTabs = TABS.filter((t) => hasRole(user, ...t.roles));
  const [active, setActive] = useState(visibleTabs[0]?.key || "questions");

  const renderContent = () => {
    switch (active) {
      case "users": return <AdminUsers />;
      case "roles": return <AdminRoles />;
      case "questions": return <AdminQuestions />;
      case "fronts": return <AdminFronts />;
      case "settings": return <AdminSettings />;
      case "qrcodes": return <AdminQRCodes />;
      case "history": return <AdminStatusHistory />;
      case "journal": return <AdminAuditLog />;
      default: return null;
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 space-y-6">
      <div className="print:hidden">
        <div className="text-xs font-mono uppercase tracking-[0.25em] text-cyan-500 mb-1">Administration</div>
        <h1 className="text-3xl font-black uppercase tracking-tight text-slate-50">Configuration & gestion</h1>
      </div>
      <div className="flex gap-1.5 overflow-x-auto pb-1 border-b border-slate-800 print:hidden">
        {visibleTabs.map((t) => (
          <button
            key={t.key}
            data-testid={`admin-nav-tab-${t.key}`}
            onClick={() => setActive(t.key)}
            className={`flex items-center gap-1.5 px-4 py-2.5 rounded-t-lg text-xs font-bold uppercase tracking-wide whitespace-nowrap transition-colors ${
              active === t.key ? "bg-[#121820] text-cyan-300 border border-slate-800 border-b-0" : "text-slate-500 hover:text-slate-300"
            }`}
          >
            <t.icon className="w-4 h-4" /> {t.label}
          </button>
        ))}
      </div>
      <div>{renderContent()}</div>
    </div>
  );
}
